"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurCraft() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const coffee = [{
    name: "Precision Cut",
    price: "£65",
    desc: "Tailored shaping for your unique hair texture"
  }, {
    name: "Signature Blowout",
    price: "£45",
    desc: "Voluminous finish with professional styling"
  }, {
    name: "Root Touch-Up",
    price: "£80",
    desc: "Seamless grey coverage and color refresh"
  }, {
    name: "Gloss Treatment",
    price: "£50",
    desc: "High-shine finish for vibrant, healthy hair"
  }, {
    name: "Deep Conditioning",
    price: "£40",
    desc: "Intensive moisture for damaged strands"
  }, {
    name: "Scalp Therapy",
    price: "£55",
    desc: "Exfoliating treatment for optimal hair health"
  }];
  const teas = [{
    name: "Balayage",
    price: "£180",
    desc: "Hand-painted highlights for a sun-kissed look"
  }, {
    name: "Full Highlights",
    price: "£210",
    desc: "Brightening from root to tip for dimension"
  }, {
    name: "Ombré Transformation",
    price: "£195",
    desc: "Soft gradient color from dark to light"
  }, {
    name: "Creative Color",
    price: "£250",
    desc: "Vibrant, custom-mixed fashion shades"
  }, {
    name: "Babylights",
    price: "£170",
    desc: "Delicate, natural-looking micro-highlights"
  }, {
    name: "Root Smudge",
    price: "£60",
    desc: "Softening the transition for a lived-in feel"
  }];
  const pastries = [{
    name: "Extension Install",
    price: "£300",
    desc: "Seamless application for added length/volume"
  }, {
    name: "Extension Move-up",
    price: "£150",
    desc: "Maintenance for your existing extensions"
  }, {
    name: "Bridal Styling",
    price: "£200",
    desc: "Bespoke up-dos for your special day"
  }, {
    name: "Event Up-do",
    price: "£95",
    desc: "Sophisticated styling for any occasion"
  }, {
    name: "Consultation",
    price: "£0",
    desc: "Personalized plan for your hair journey"
  }, {
    name: "Pricing Guide",
    price: "PDF",
    desc: "Download our full salon service menu"
  }];
  const groups = [{
    label: "Essential Styling",
    items: coffee
  }, {
    label: "Color Artistry",
    items: teas
  }, {
    label: "Specialized Services",
    items: pastries
  }];
  return <section data-section-id="1997" id="our-craft" ref={ref} className="bg-background text-foreground border-t border-border py-24 md:py-32 px-6 md:px-10 lg:px-16">
      <div className="mx-auto max-w-[1280px]">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 mb-20 md:mb-24">
          <div className={`lg:col-span-5 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-default text-xs uppercase tracking-[0.16em] text-foreground/70 mb-6">OUR SERVICES</p>
            <h2 className="font-default text-4xl md:text-5xl lg:text-[3.25rem] font-normal leading-[1.08] tracking-tight text-foreground">
              Crafted <em className="italic">precisely</em>, styled beautifully.
            </h2>
            <div className="mt-8 flex items-center gap-0 max-w-[200px]">
              <div className="h-px flex-1 bg-border" />
              <div className="h-1.5 w-1.5 rounded-lg bg-primary ml-0" />
            </div>
          </div>

          <div className={`lg:col-span-7 lg:pt-2 flex items-end transition-all duration-700 ease-out delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-default italic text-lg md:text-xl leading-[1.55] text-foreground/70">
              At Velvet Shears, we believe in the art of hair. From precision cuts to bespoke color transformations, our stylists use premium techniques to ensure your hair reflects your unique personality and lifestyle.
            </p>
          </div>
        </div>

        {}
        <div className="relative">
          {}
          <div aria-hidden="true" className="pointer-events-none absolute -top-8 right-0 lg:right-4 font-default text-[12rem] md:text-[16rem] leading-none text-foreground/[0.05] select-none">
            II
          </div>

          <div className="relative grid grid-cols-1 lg:grid-cols-3 gap-y-14 lg:gap-y-0 lg:divide-x lg:divide-border">
            {groups.map((group, i) => <div data-index={i} key={group.label} className={`lg:px-8 first:lg:pl-0 last:lg:pr-0 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
            transitionDelay: `${200 + i * 120}ms`
          }}>
                <div className="lg:hidden border-t border-border mb-10" />

                <p className="font-default text-[11px] uppercase tracking-[0.16em] text-foreground/55 mb-8">
                  {group.label}
                </p>

                <ul className="space-y-7">
                  {group.items.map((item, j) => <li data-index={j} key={item.name}>
                      <div className="flex items-baseline gap-2">
                        <span className="font-default text-base md:text-lg text-foreground">
                          {item.name}
                        </span>
                        <span aria-hidden="true" className="flex-1 font-default text-foreground/30 text-xs overflow-hidden whitespace-nowrap tracking-[0.3em] translate-y-[-2px]">
                          ........................................................
                        </span>
                        <span className="font-default text-sm text-foreground tabular-nums">
                          {item.price}
                        </span>
                      </div>
                      <p className="mt-1.5 font-default italic text-[13px] leading-[1.4] text-foreground/55">
                        {item.desc}
                      </p>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        {}
        <div className="mt-20 md:mt-24 border-t border-border pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="font-default italic text-[13px] leading-[1.5] text-foreground/45 max-w-xl">
            Prices may vary based on hair length and complexity — book a consultation for a custom quote
          </p>
          <p className="font-default text-[11px] uppercase tracking-[0.16em] text-foreground/45">
            Velvet Shears — Est. MMXXIV
          </p>
        </div>
      </div>
    </section>;
}